<div class="quienes-somos">
  <div class="qs-container">
    <div class="qs-grid">
      <!-- Columna izquierda: texto -->
      <div class="qs-texto">
        <span class="sub-title">Quienes Somos</span>
        <p>
          <strong>
            Los beneficiarios de nuestra Obra Social, Signo Médico, cuentan con una amplia y libre elección de Profesionales e
            Instituciones Sanatoriales prestigiosas en todo el País. Para saber más sobre el detalle de toda la cobertura y
            las normas de utilización de los servicios, le sugerimos ver la Norma de Cobertura correspondiente a su plan en
            <a href="http://www.osoetsylra.org" target="_blank">www.osoetsylra.org</a>
          </strong>
        </p>
      </div>
      <!-- Columna derecha: imagen -->
      <div class="qs-imagen">
        <img src="assets/img/quienes-somos/signomedico.png" alt="Signo Médico">
      </div>
    </div>
  </div>
</div>